import Api from './Api'
import {
  PrescriptionDraft,
  PublicPrescription,
} from 'components/screen/dashboard/peopleSection/Prescription/publicPrescriptionModel'

let serverOffset = 0
export const serverNow = (): number => Date.now() + serverOffset

class PublicPrescriptionApi extends Api {
  private syncClock(headers: { date?: string }): void {
    const serverDate = Date.parse(headers.date || '')
    if (Number.isFinite(serverDate)) serverOffset = serverDate - Date.now()
  }

  list = async (
    page = 0,
    top = 10,
  ): Promise<{ items: PublicPrescription[]; count: number }> => {
    const response = await this.postJsonData(
      `/Prescription/GetPrescriptionOfUser?$top=${top}&$skip=${
        page * top
      }&$orderby=id desc`,
    )
    this.syncClock(response.headers)
    return response.data
  }

  all = async (): Promise<PublicPrescription[]> => {
    let items: PublicPrescription[] = []
    let page = 0
    let count = Infinity
    while (items.length < count) {
      const result = await this.list(page++, 100)
      items = items.concat(result.items)
      count = result.count
      if (result.items.length < 100) break
    }
    return items
  }

  detail = async (id: number): Promise<PublicPrescription> => {
    const response = await this.postJsonData(`/Prescription/Detail/${id}`)
    this.syncClock(response.headers)
    return response.data.data || response.data
  }

  submit = async (draft: PrescriptionDraft): Promise<number> => {
    const query = new URLSearchParams({
      duration: '2',
      provinceCode: draft.provinceCode,
      cityCode: draft.cityCode,
      allowOtherProvinces: String(draft.allowOtherProvinces),
      isSath2: 'false',
      isSath3: String(draft.isSath3),
      pharmacyCode: draft.pharmacyCode.trim(),
    })
    const form = new FormData()
    form.append('comment', draft.comment.trim())
    if (draft.image)
      form.append(
        'file',
        await (await fetch(draft.image)).blob(),
        draft.imageName,
      )
    const response = await this.postMultipartData(
      `/Prescription/SendPublic?${query}`,
      form,
    )
    const id = response.data.data && response.data.data.prescriptionID
    if (!id)
      throw new Error(
        'پاسخ ثبت درخواست فاقد کد پیگیری است؛ قبل از تلاش دوباره، درخواست‌های من را بررسی کنید.',
      )
    return id
  }

  receipt = async (id: number, file: File): Promise<void> => {
    const form = new FormData()
    form.append('file', file)
    await this.postMultipartData(
      `/Prescription/SubmitReceipt?prescriptionID=${id}`,
      form,
    )
  }

  provinces = async (): Promise<{ items: { code: string; name: string }[] }> =>
    (await this.postJsonData('/CountryDivision/AllProvince2?$top=200')).data
  cities = async (
    code: string,
  ): Promise<{ items: { code: string; name: string }[] }> =>
    (
      await this.postJsonData(
        `/CountryDivision/AllCities2?provinceCode=${encodeURIComponent(
          code,
        )}&$top=500`,
      )
    ).data
}

export default new PublicPrescriptionApi()
